export enum SalesArticleTreatmentServicesType {
    SalesArticle = 'SalesArticle',
    StdTreatement = 'StdTreatement',
    Services = 'Services'
  }